// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G-2uD","delete":"styles_delete__8qXjq","update":"styles_update__1k43K","add":"styles_add__18ke8"};